module.exports = __webpack_public_path__ + "static/media/done.35f03116.svg";